import React, { useEffect } from "react";
import { useState } from "react";
import BaseButton from "../../components/common/Button/BaseButton";
import InputPassWord from "../../components/common/Input/InputPassWord";
import InputText from "../../components/common/Input/InputText";
import SelectLanguage from "../../components/common/Selector/SelectLanguage";
import "../../assets/style/pageStyle/login.scss";
import { IconLogo, IconPassWord, IconUserName } from "../../assets/icon";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { login } from "../../services/slice/AuthSlice";
import { useNavigate } from "react-router-dom";
import { getStateLogin } from "../../services/selector/AuthSelector";
import Loading from "../../components/common/Loading";
const Login = () => {
  const { t } = useTranslation();
  const stateAuth = useSelector(getStateLogin);
  const { isLogin, msg, isLoading } = stateAuth;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [dataLogin, setDataLogin] = useState({
    username: "",
    password: "",
  });
  const [error, setError] = useState("");

  const validate = () => {
    let isValid = true;
    if (!dataLogin.username) {
      isValid = false;
      setError("Tên đăng nhập không được để trống.");
    } else if (!dataLogin.password) {
      isValid = false;
      setError("Mật khẩu không được để trống.");
    } else {
      isValid = true;
      setError("");
    }
    return isValid;
  };
  const handleSubmit = () => {
    if (!validate()) return;
    dispatch(login(dataLogin));
  };
  useEffect(() => {
    const router = localStorage.getItem("keyMenu");
    if (isLogin) return navigate(router ? `/${router}` : "/");
    else {
      setError(msg);
      return;
    }
  }, [isLogin, msg]);
  return (
    <div className="wrapperLogin">
      <div
        className="formLogin"
        onKeyDown={(e) => {
          if (e.key === "Enter") handleSubmit();
          return;
        }}
      >
        <div className="header">
          <div className="ChangeLanguage">
            <SelectLanguage style={{ color: "white" }} width={130} />
          </div>
        </div>
        <div className="containerForm">
          <div className="headerForm">
            <IconLogo />
            <span id="name">Customer Connection Platform</span>
          </div>
          <div className="groupInput">
            <div className="itemInput">
              <InputText
                focus
                prefix={<IconUserName />}
                typeInput={"inputRound"}
                style={{
                  width: 470,
                  height: "4.3rem",
                }}
                text={dataLogin.username}
                setText={(value) => {
                  setError("");
                  setDataLogin({ ...dataLogin, username: value });
                }}
                placeholder="Tên đăng nhập"
              />
              {error && !dataLogin.username ? (
                <small className="msgError">{t(error)}</small>
              ) : null}
            </div>
            <div className="itemInput">
              <InputPassWord
                prefix={<IconPassWord />}
                typeInput={"inputRound"}
                style={{
                  width: 470,

                  height: "4.3rem",
                }}
                password={dataLogin.password}
                setPassWord={(value) => {
                  setError("");
                  setDataLogin({ ...dataLogin, password: value });
                }}
              />
              {error && dataLogin.username ? (
                <small className="msgError">{t(error)}</small>
              ) : null}
            </div>
            <Loading isloading={isLoading}>
              <BaseButton
                disabled={isLoading}
                typeBtn="btn_Login "
                styleBtn={{ height: "4.3rem" }}
                width={180}
                color="white"
                handleClick={handleSubmit}
                content="Đăng nhập"
              />
            </Loading>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
